import React from "react";
import { formattedAmount } from "../../../../utils/helpers/Functions.helper";


const ModifierTable = ({ data }) => {
  return (
    <div className="mb-4 ">
      <h4 className="text-l font-bold">Modifiers:</h4>
      <div id="bot" className="overflow-x-auto">
        <table className="table-auto w-full border-collapse border border-gray-300">
          <thead >
            <tr className="bg-gray-200">
              <th className="">Modifier Category</th>
              <th className="">Modifiers</th>
              {/* <th className="">Price ($)</th> */}
            </tr>
          </thead>
          <tbody>
            {data.map((category) =>category?.modifier_category? (
              <React.Fragment>
              <tr key={category._id} className="hover:bg-gray-100">
                <td                 
                  className="border border-gray-200 text-center align-middle font-semibold"
                >
                  {category.modifier_category}
                </td>
               <td style={{padding:'0'}}>

              {category.modifiers.map((modifier, index) => (
                  <tr key={modifier._id}>
                    {/* {index > 0 && <tr className="hover:bg-gray-100" />} */}
                    <td style={{width:'100%'}}>
                      {modifier.name}
                    </td>
                    <td style={{width:'100%'}}>
                      {formattedAmount(modifier.price.$numberDecimal)}
                    </td>
                  </tr>
                ))}
               </td>
              </tr>
              
              
              </React.Fragment>
            ):"")}
          </tbody>
        </table>
      </div>
      <hr />
    </div>
  );
};


export default ModifierTable